import * as Sentry from '@sentry/react';
import { CaptureConsole } from '@sentry/integrations';
import { BrowserTracing } from '@sentry/tracing';

export default () =>
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [
      new BrowserTracing(),
      new CaptureConsole({
        levels: ['warn', 'error'],
      }),
    ],
    environment: 'production',
    tracesSampleRate: 0.2,
    initialScope: {
      tags: {
        environment: 'production',
        projectName: 'payment-link-front',
      },
    },
  });
